import { DriveStep } from "driver.js";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";

import { useDriverTour } from "./useDriverTour";

/**
 * CLE-3015 PR 0 (spike) — one tour step on the hospital Estimates tab, started only when the URL
 * carries `?tourSpike=1`. Harmless if it ships: without the param it renders nothing and never
 * creates a driver. Deliberately NOT gated on NODE_ENV (dev runs a production build). Removed in
 * PR 2, when the real engine (spa/src/training/) lands.
 */
export const NEW_ESTIMATE_SELECTOR =
  '[data-testid="create_new_order_OrderTable"]';
export const TOUR_SPIKE_TEXT = "Every estimate starts here.";
/** The spec's default `waitForElement`: the table header may mount after its data loads. */
export const TOUR_SPIKE_WAIT_MS = 8000;

const STEPS: DriveStep[] = [
  {
    element: NEW_ESTIMATE_SELECTOR,
    // `click` step (spec §5): advance when the trainee clicks the real button; no Next button.
    advanceOnClick: true,
    waitForElement: TOUR_SPIKE_WAIT_MS,
    skipMissingElement: true,
    popover: {
      title: "Clear Certified",
      description: TOUR_SPIKE_TEXT,
      side: "bottom",
      align: "end",
      showButtons: [],
    },
  },
];

function SpikePopoverContent({ onExit }: { onExit: () => void }) {
  return (
    <div className="mt-2 flex align-items-center justify-content-between gap-2">
      <span>Click New Estimate to begin.</span>
      <button
        type="button"
        className="p-button p-button-text p-button-sm"
        onClick={onExit}
      >
        Exit tour
      </button>
    </div>
  );
}

export function TourSpike() {
  const { search } = useLocation();
  const enabled = new URLSearchParams(search).get("tourSpike") === "1";
  const { popoverContainer, destroy } = useDriverTour({
    steps: STEPS,
    enabled,
  });

  return popoverContainer
    ? createPortal(<SpikePopoverContent onExit={destroy} />, popoverContainer)
    : null;
}
